<template>
  <div class="result" v-buried data-buried="BG_KXJIEGUOYE">
    <AppNavbar
      v-if="isApp"
      :options="options"
      :placeholder="true"
      :zIndex="999"
      title="我的科学定制营养方案"
    >
    </AppNavbar>
    <div class="content" v-if="info" id="content">
      <div class="tips">*注：该定制方案仅供您本人使用，他人使用不保证效果</div>
      <ResultContent1
        class="content-1"
        style="margin-bottom: 30px"
        :info="info"
      />
      <div class="method">
        <div class="m-text"
          >以下是<span class="bold">{{ info.fatTargetResult.expert_name }}</span
          >为您量身定制的营养方案</div
        >
      </div>
      <!-- 导航 -->
      <div
        class="nav-list"
        id="nav-list"
        :style="{ top: navTop + 'px', backgroundColor: navBackgroundColor }"
      >
        <div
          class="nav-item"
          :class="{ 'nav-item-active': curNav == index }"
          v-for="(item, index) in navList"
          :key="index"
          @click="bindClickNav(index)"
          v-buried
          :data-buried="item.buriedData"
          v-clickBuried
          :data-click-buried="item.clickBuriedData"
        >
          <div class="hot" v-if="item.hot">HOT</div>
          {{ item.title }}
        </div>
      </div>
      <ResultContent2 :info="info" />
      <ResultContent3 :info="info" />
      <ResultContent4 :info="info" />
      <ResultContent5 :info="info" />
      <ResultContent6 :info="info" />
    </div>
    <van-overlay :show="showToast" z-index="3000">
      <div class="wrapper" @click.stop v-if="toastData">
        <img class="w-image" :src="toastData.image" alt="" />
        <div class="w-title" v-if="toastData.title">{{ toastData.title }}</div>
        <div class="w-content">
          <div class="w-text" v-html="toastData.text"></div>
          <div class="w-btn" @click="showToast = false">确认</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import AppNavbar from '@/components/app/nav-bar/index.vue'
import ResultContent1 from './components/result/content1.vue'
import ResultContent2 from './components/result/content2.vue'
import ResultContent3 from './components/result/content3.vue'
import ResultContent4 from './components/result/content4.vue'
import ResultContent5 from './components/result/content5.vue'
import ResultContent6 from './components/result/content6.vue'
export default {
  name: 'cna-question-v2-result',
  components: {
    AppNavbar,
    ResultContent1,
    ResultContent2,
    ResultContent3,
    ResultContent4,
    ResultContent5,
    ResultContent6
  },
  provide() {
    return {
      bindShowToast: this.bindShowToast
    }
  },
  data() {
    return {
      isApp: false,
      id: 0, //结果id
      options: {
        barBackgroundColor: 'transparent',
        color: 'rgba(0,0,0,0.8)'
      },
      navTop: 60,
      curNav: 0,
      showToast: false,
      toastData: {
        image:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a6c824b1afb3d1e0317c24c0d8dd1851.png',
        title: '温馨提示',
        text: '结合您目前的身体问题、服用药物、过敏忌口等信息，无法为您生成合理的科学定制营养方案，请<span style="color:#9890FD">联系客服</span>或<span style="color:#9890FD">您的营养师</span>寻求方案。'
      },
      navList: [
        {
          title: '健康报告',
          id: '',
          buriedData: 'BG_JIANKANGBAOGAO_TAB',
          clickBuriedData: 'CLICK_JIANKANGBAOGAO_TAB'
        },
        {
          title: '定制饮食',
          id: '',
          hot: true,
          buriedData: 'BG_DINGZHIYINSHI_TAB',
          clickBuriedData: 'CLICK_DINGZHIYINSHI_TAB'
        },
        {
          title: '真人营养师服务',
          id: '',
          buriedData: 'BG_YINGYANGSHI_TAB',
          clickBuriedData: 'CLICK_YINGYANGSHI_TAB'
        }
      ],
      info: null,
      navBackgroundColor: 'rgba(255,255,255,0)'
    }
  },
  watch: {
    id() {
      this.info = null
      this.setQueId(this.id)
      this.setMenuData(null)
      this.getResult()
    }
  },
  created() {
    this.isApp = this.$betterwe.isApp()
    this.getTabBar()
  },
  mounted() {
    this.addScroll()
  },
  activated() {
    this.id = this.$route.query.id
  },
  beforeDestroy() {
    this.removeScroll()
  },
  methods: {
    ...mapMutations('cnaV2', ['setResultData', 'setQueId', 'setMenuData']),
    bindShowToast() {
      this.showToast = true
    },
    async getTabBar() {
      let res = await this.$betterwe.getAppBarHeight().catch(() => {})
      if (res) {
        this.navTop = res.toolsBarHeight + res.statusBarHeight
      } else {
        this.navTop = 0
      }
    },
    getResult() {
      let params = {
        cna_new_id: this.id
      }
      this.$http
        .getBaseApp('que/CnaV2/getCnaAnswer', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.info = res.data
            this.setResultData(res.data)
          } else {
            this.$toast(res.msg)
          }
        })
        .finally(() => {})
    },
    dealData(list) {
      list.selfControl.map((dayitem, dayindex) => {
        dayitem.data.map((mealitem, mealindex) => {
          if (!mealitem.meal_data) {
            mealitem.meal_data = []
          }
          mealitem.meal_data = mealitem.meal_data.filter((typeitem) => {
            typeitem.data = typeitem.data.filter((fooditem) => {
              return fooditem
            })
            return typeitem.data.length
          })
        })
      })
      /* 将外卖中的food_attr_ids的id数组处理成文字 */
      let foodTypeObj = {}
      list.scienceFoodAttr.map((item) => {
        foodTypeObj[item.id] = item
      })
      list.takeAway.map((dayitem, dayindex) => {
        dayitem.data.map((mealitem, mealindex) => {
          mealitem.meal_data.food_list.map((fooditem) => {
            if (fooditem.food_attr_ids && fooditem.food_attr_ids.length) {
              let attrName = ''
              fooditem.food_attr_ids.map((attrItem, attrIndex) => {
                if (attrIndex < fooditem.food_attr_ids.length - 1) {
                  attrName = attrName + foodTypeObj[attrItem].name + '+'
                } else {
                  attrName = attrName + foodTypeObj[attrItem].name
                }
              })
              fooditem.attr_name = attrName
            }
          })
        })
      })
      let res = [
        {
          title: '自制版',
          data: list.selfControl || []
        },
        {
          title: '外卖版',
          data: list.takeAway || []
        }
      ]
      return res
    },
    bindClickNav(index) {
      this.curNav = index
      let scrollTop = document.getElementById('nav-id-' + index).offsetTop
      scrollTop = Math.round(scrollTop - (this.navTop + 52))
      document.documentElement.scrollTop = scrollTop >= 0 ? scrollTop : 0
      document.body.scrollTop = scrollTop >= 0 ? scrollTop : 0
    },
    bindScroll(e) {
      let maxHeight = 100
      var scroll = Math.round(
        document.documentElement.scrollTop || document.body.scrollTop
      )
      let navEl = document.getElementById('nav-list')
      if (!navEl) {
        return
      }
      let navTop = Math.round(navEl.offsetTop)
      if (Math.abs(navTop - scroll) < 1) {
        this.navBackgroundColor = 'rgba(255,255,255,1)'
      } else {
        this.navBackgroundColor = 'rgba(255,255,255,0)'
      }
      /*  */
      this.curNav = this.computedCurNav()
      if (scroll < maxHeight) {
        scroll = scroll < 0 ? 0 : scroll
        this.options.barBackgroundColor =
          'rgba(255,255,255,' + (scroll / maxHeight).toFixed(2) + ')'
      } else {
        this.options.barBackgroundColor = 'rgba(255,255,255,1)'
      }
    },
    computedCurNav() {
      var scroll = Math.round(
        document.documentElement.scrollTop || document.body.scrollTop
      )
      let index = 0
      for (let i = 0; i < this.navList.length; i++) {
        let el = document.getElementById('nav-id-' + i)
        if (el) {
          //let offsetTop = Math.round(el.offsetTop - (this.navTop + 52));
          let offsetTop =
            el.getBoundingClientRect().top -
            document.getElementById('content').getBoundingClientRect().top
          if (scroll >= offsetTop) {
            index = i
          }
        }
      }
      return index
    },
    addScroll() {
      window.addEventListener('scroll', this.bindScroll)
    },
    removeScroll() {
      window.removeEventListener('scroll', this.bindScroll)
    },
    // 获取数据
    async loadData() {
      try {
        let res = await this.$http.getBaseApp('member/AppCamp/getCNAScheme', {
          rid: 30551
        })
        let { code, data } = res?.data?.data
        if (code == 1) {
          this.$toast.clear()
          // 雷达图
          let indicatorList = ['运动', '饮食', '体质', '情绪', '习惯', '睡眠']
          let yourScore = []
          let averageScore = []
          indicatorList.forEach((item) => {
            let scoreArr = data?.radarResult?.data.filter(
              (actItem) => actItem.name == item
            )
            yourScore.push(scoreArr[0].score)
          })

          indicatorList.forEach((item) => {
            let scoreArr = data?.radarResult?.averageData.filter(
              (actItem) => actItem.name == item
            )
            averageScore.push(scoreArr[0].score)
          })
          this.$refs.resultChart.initChart(yourScore, averageScore)
        } else {
          this.$toast.clear()
          this.$toast.fail({
            message: res?.data?.data?.msg
          })
        }
      } catch (err) {
        this.$toast.clear()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.result {
  min-height: 100vh;
  padding-bottom: 40px;
  background-color: #f9f9f9;
  background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/3ee67ed29bbe4a3bf7017f157d92a73f.png');
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center top;

  .content {
    position: relative;

    .tips {
      height: 29px;
      padding: 0px 20px;
      background: rgba(255, 255, 255, 0.35);
      backdrop-filter: blur(2px);
      font-size: 11px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 29px;
      margin-bottom: 20px;
    }

    .content-1 {
      width: 335px;
      margin: 0 auto;
    }

    .method {
      margin-bottom: 24px;
      padding: 0px 20px;
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 14px;
      display: flex;
      align-items: center;

      .m-text {
        margin: 0 10px;

        .bold {
          font-weight: 600;
        }
      }
    }

    .method::before {
      content: '';
      flex: 1;
      height: 1px;
      background-color: #dddddd;
    }

    .method::after {
      content: '';
      flex: 1;
      height: 1px;
      background-color: #dddddd;
    }
  }

  .nav-list {
    box-sizing: border-box;
    position: sticky;
    width: 100%;
    top: 60px;
    z-index: 999;
    display: flex;
    align-items: center;
    padding: 8px 18px 8px;
    margin-bottom: 12px;

    .nav-item {
      box-sizing: border-box;
      min-width: 100px;
      height: 36px;
      padding: 0px 8px;
      line-height: 36px;
      background: #ededed;
      border-radius: 8px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.7);
      margin-right: 10px;
      text-align: center;
      position: relative;

      .hot {
        position: absolute;
        right: 2px;
        top: 0;
        transform: translate(0%, -50%);
        text-align: center;
        width: 29px;
        height: 16px;
        font-size: 10px;
        font-family: Alibaba-PuHuiTi-B, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #ffffff;
        line-height: 16px;
        background: #fd6181;
        border-radius: 9px 9px 9px 0px;
      }
    }

    .nav-item:last-child {
      margin-right: 0;
    }

    .nav-item-active {
      background: #6759ff;
      color: #fff;
    }
  }
}

.wrapper {
  overflow: hidden;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 295px;
  background: #ffffff;
  border-radius: 12px;

  .w-title {
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
    margin-bottom: 12px;
  }

  .w-image {
    width: 100%;
    height: 104px;
    object-fit: contain;
    min-height: 20px;
    margin-bottom: 2px;
  }

  .w-content {
    padding: 0px 20px 20px;
  }

  .w-text {
    margin-bottom: 26px;
    font-size: 15px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(0, 0, 0, 0.8);
    line-height: 22px;
  }

  .w-btn {
    text-align: center;
    height: 44px;
    background: #9890fd;
    border-radius: 12px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 44px;
  }
}
</style>
